export const free_spin_page_win = {
	FREE_SPIN_HEADER: {
		value: 'CONGRATULATIONS!',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},

	FREE_SPIN_WIN_TITLE: {
		value: 'IN GIFTED FREE SPINS YOU HAVE WON',
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28,
			wordWrap: true,
			wordWrapWidth: 300,
			align: 'center'
		}
	},
	FREE_SPIN_TOTAL_AMOUNT: {
		value: '',
		config: {
			lineHeight: 1,
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	FREE_SPIN_TOTAL_TEXT: {
		value: 'TOTAL',
		config: {
			fontFamily: 'Japanese',
			fontSize: 60,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	FREE_SPIN_BTN: {
		value: 'OK',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	}
};
